const ctx = require.context("../data/migrated", false, /\.json$/);
const thumbsData = ctx("./blog-thumbs.json");
const indexData = ctx("./index.json");

const CATEGORY_RULES = [
  [/franchis/i, "Franchising"],
  [/cost|money|profit|unit-economic|capex|margin/i, "Economics"],
  [/swiggy|zomato|aggregator|delivery|online|ordering/i, "Delivery"],
  [/employee|staff|manpower|team/i, "Operations"],
  [/location|bangalore|near-me/i, "Bangalore"],
  [/marketing|loyalty/i, "Marketing"],
  [/license|permit/i, "Compliance"],
  [/trend/i, "Trends"],
  [/software|inventory|tracking|tech/i, "Technology"],
  [/scal|expand|grow/i, "Scaling"],
  [/start|checklist|home|bakery|meal-prep|skill/i, "Guides"],
];

export const categoryOf = (text) =>
  CATEGORY_RULES.find(([re]) => re.test(text))?.[1] || "Cloud Kitchens";

export const blogList = indexData
  .filter((b) => b.type === "blog")
  .map((b) => {
    const t = thumbsData[b.url] || {};
    const title = (t.title || b.title || "").replace(/ \| Skope Kitchens$/, "");
    return {
      url: b.url,
      title,
      description: (t.metaDescription || b.metaDescription || "").trim(),
      image: t.image || null,
      category: categoryOf(`${title} ${b.url}`),
    };
  })
  .sort((a, b) => a.title.localeCompare(b.title));
